import { GET_USER, GET_SEARCH_USERS, GET_MAILBOX, GET_THREAD, POST_MESSAGE, PUT_MESSAGE, SELECT_USER, SET_VALUE } from './actions';

const initialState = {
  /**
   * The compose data to send a new message
   */
  compose: {
    search: '',
    results: [],
    to: {},
    subject: '',
    content: '',
  },

  /**
   * All messages in the inbox
   */
  inbox: {
    total: 0,
    list: [],
  },

  /**
   * Sent messages
   */
  sent: {
    total: 0,
    list: [],
  },

  /**
   * Selected thread
   */
  thread: {
    title: '',
    messages: [],
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_USER.SUCCESS:
      return {
        ...state,
        compose: {
          ...state.compose,
          search: action.payload.user.name,
          to: action.payload.user,
        },
      };
    case GET_SEARCH_USERS.REQUEST:
      return {
        ...state,
        compose: {
          ...state.compose,
          search: action.data.query,
          to: {},
        },
      };
    case GET_SEARCH_USERS.SUCCESS:
      return {
        ...state,
        compose: {
          ...state.compose,
          results: action.payload.users,
        },
      };
    case GET_MAILBOX.SUCCESS:
      return {
        ...state,
        [action.data.list]: {
          ...state[action.data.list],
          total: action.payload.meta.total,
          list: action.payload.threads,
        },
      };
    case GET_THREAD.SUCCESS:
      return {
        ...state,
        thread: action.payload.thread,
      };
    case POST_MESSAGE.SUCCESS:
      return {
        ...state,
        compose: initialState.compose,
      };
    case PUT_MESSAGE.SUCCESS:
      return {
        ...state,
        thread: {
          ...state.thread,
          messages: [
            ...state.thread.messages,
            {
              ...action.data,
              ...action.payload.message,
              time: new Date(),
            }
          ],
        }
      };
    case SELECT_USER:
      return {
        ...state,
        compose: {
          ...state.compose,
          search: action.payload.user.name,
          to: action.payload.user,
        },
      };
    case SET_VALUE:
      return {
        ...state,
        compose: {
          ...state.compose,
          [action.payload.name]: action.payload.value,
        },
      };
    default:
      return state;
  }
}